module.exports = __webpack_public_path__ + "img/rhea.a5e6ede0.png";